export const SafeIdMixin = {
  data: () => ({
    localId: null
  }),
  methods: {
    safeId(prefix,order='prefix') {
      const id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      prefix = String(prefix || '').replace(/\s+/g, '_')
      
      if ( prefix && order == 'prefix' ) {
        return `${prefix}_${id}` 
      } else if ( prefix && order == 'id' ) {
        return `${id}_${prefix}`
      } else {
        return id
      }
    }
  },
}